module.exports = __webpack_public_path__ + "Roboto-Regular.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Regular.eot
// module id = ../../../../../src/font/roboto/Roboto-Regular.eot
// module chunks = 1